/**
 * Utility functions for PowerEditor component
 */

import {
    TEMPLATE_PORT_MAP,
    DEFAULT_APP_SERVICE,
} from "@/constants/power-editor.constants";

/**
 * Resolve app service from template port
 */
function resolveAppServiceFromPort(templatePort: string | undefined): {
    service: string;
    port: number;
} {
    if (!templatePort) {
        return DEFAULT_APP_SERVICE;
    }

    return TEMPLATE_PORT_MAP[templatePort] || DEFAULT_APP_SERVICE;
}

/**
 * Extract error message from API error response
 */
function extractErrorMessage(err: any, fallbackMessage: string): string {
    return err.response?.data?.error || fallbackMessage;
}

export { resolveAppServiceFromPort, extractErrorMessage };
